import { connect } from 'react-redux';
import { useProperty } from '@eti/providers';
import { change } from 'redux-form';
import SmallCardLayout from '../../../common/components/small-card-layout/SmallCardLayout';
import { wrapperStyles } from '../../common/styles';
import { useProductData } from '../../../common/hook/useProductData';
import TaxIdInput from '../../common/components/TaxIdInput';
import ProductLayout from '../../../common/main-layout/ProductLayout';
import { getSelected } from '../../../single-choice/utils/selection';
import { travelerInputs } from '@eti/utils';
import { getSessionTaxId, getTaxId } from '../../common/utils/utils';
import { ProductCardLayoutType } from '../../../common/models/product';
import { TRAVEL_INSURANCE_INSIDE_EU } from '../../../products';
import { jsx as _jsx, Fragment as _Fragment, jsxs as _jsxs } from "react/jsx-runtime";
const {
  TAX_ID_INPUT
} = travelerInputs;
const {
  name: PRODUCT_NAME,
  id: PRODUCT_ID
} = TRAVEL_INSURANCE_INSIDE_EU;
const {
  Small: SMALL_CARD_LAYOUT,
  Main: MAIN_CARD_LAYOUT,
  PostBooking: POSTBOOKING_CARD_LAYOUT
} = ProductCardLayoutType;
const sharedTexts = {
  confirmationContent: 'travelInsuranceInsideEUConfirmationContent',
  confirmText: 'travelInsuranceInsideEUConfirmationYes',
  declineText: 'travelInsuranceInsideEUConfirmationNo',
  persuasionContent: 'travelInsuranceInsideEUPersuasionContent',
  readMoreContent: 'travelInsuranceInsideEUReadMoreModalContent',
  title: 'travelInsuranceInsideEUTitle'
};
const mainCardTranslations = {
  ...sharedTexts,
  abstractContent: 'travelInsuranceInsideEUAbstract',
  additionalInformation: 'travelInsuranceInsideEUAdditionalInformation',
  upSell: 'travelInsuranceInsideEUUpSellText'
};
const translations = {
  [MAIN_CARD_LAYOUT]: mainCardTranslations,
  [POSTBOOKING_CARD_LAYOUT]: mainCardTranslations,
  [SMALL_CARD_LAYOUT]: {
    ...sharedTexts,
    abstractContent: 'travelInsuranceInsideEUAbstractSmallCard',
    upSell: 'travelInsuranceInsideEUUpSellTextSmallCard'
  }
};
export const TravelInsuranceInsideEu = ({
  className,
  form,
  order,
  productCode,
  productPosition,
  isSelected,
  sellSpecification,
  layoutType = MAIN_CARD_LAYOUT,
  taxId,
  onTaxIdChange
}) => {
  const {
    p
  } = useProperty();
  const texts = translations[layoutType] || {};
  const {
    productData,
    rootElement
  } = useProductData({
    className,
    form,
    isSelected,
    layoutType,
    order,
    productId: PRODUCT_ID,
    productName: PRODUCT_NAME,
    productCode,
    productPosition,
    productType: 'traveler',
    sellSpecification,
    texts
  });
  if (!productData) {
    return null;
  }
  const shouldShowTaxIdInput = p('TravelerDetails.TaxIdFeature.Enabled') && isSelected;
  switch (layoutType) {
    case SMALL_CARD_LAYOUT:
      return /*#__PURE__*/_jsxs(_Fragment, {
        children: [/*#__PURE__*/_jsx(SmallCardLayout, {
          className: wrapperStyles(shouldShowTaxIdInput),
          productData: productData,
          ref: rootElement
        }), shouldShowTaxIdInput && /*#__PURE__*/_jsx(TaxIdInput, {
          onTaxIdChange: onTaxIdChange,
          taxId: taxId
        })]
      });
    case MAIN_CARD_LAYOUT:
    default:
      return /*#__PURE__*/_jsxs(_Fragment, {
        children: [/*#__PURE__*/_jsx(ProductLayout, {
          className: wrapperStyles(shouldShowTaxIdInput),
          productData: productData,
          ref: rootElement
        }), shouldShowTaxIdInput && /*#__PURE__*/_jsx(TaxIdInput, {
          onTaxIdChange: onTaxIdChange,
          taxId: taxId
        })]
      });
  }
};
const mapStateToProps = (state, {
  form
}) => {
  const taxId = getTaxId(TAX_ID_INPUT, form)(state) || getSessionTaxId();
  const isSelected = getSelected(TRAVEL_INSURANCE_INSIDE_EU.name, form)(state);
  return {
    isSelected,
    taxId
  };
};
const mapDispatchToProps = (dispatch, {
  form
}) => ({
  onTaxIdChange(taxId) {
    dispatch(change(form, TAX_ID_INPUT, taxId));
  }
});
export const ConnectedTravelInsuranceInsideEu = connect(mapStateToProps, mapDispatchToProps)(TravelInsuranceInsideEu);
//# sourceMappingURL=TravelInsuranceInsideEu.js.map